module.exports = __webpack_public_path__ + "img/iconmonstr-facebook-messenger-1.6cff5f79.svg";